module.exports = __webpack_public_path__ + "img/BI.61af10ef.png";